// beforeEach
// - 2023.08.08
export const beforeEach = async (to, from, next) => {
  next()
}

